export { useDeepLink } from '@white-label-store/deep-link';
export * from '@white-label-store/deep-link';
